import { AnnouncementBar } from '@/components/AnnouncementBar';
import { useAnnouncement } from '@/state/useAnnouncement';

/**
 * Mounted by the dashboard shell only. It was in the auth layout too, so that a
 * notice about signing in being broken reached the people who could not sign in,
 * but the signin screen now carries an announcements chat of its own — see
 * AuthChatPanel — and two announcement surfaces a hundred pixels apart said
 * different things.
 *
 * The route behind it is still unauthenticated, which no longer buys anything
 * here. Left as it is rather than tightened in passing: see
 * api/announcements/get-active-announcement.
 *
 * Not pinned. ExperimentStatistics pins its control bar at `fixed top-0 z-40`, and two
 * elements pinned to the same offset would overlap. They do not overlap as things stand:
 * this bar is in the flow at the top of the page, and the control bar only appears once
 * the evaluation card has scrolled past, by which point this one is well out of view.
 *
 * It was `sticky top-0 z-40` on the control bar until f8f84e6, which found that sticky
 * never engaged at all: SidebarInset has `overflow-auto` with only `min-h-svh`, so it is
 * the nearest scroll container but never scrolls, and the window scrolls instead.
 */
export const GlobalAnnouncement = () => {
  const { announcement, dismiss } = useAnnouncement();

  if (!announcement) return null;

  return <AnnouncementBar announcement={announcement} onDismiss={dismiss} />;
};
